import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

import { ExternalBundlesLoader } from './external-bundles-loader';

export type WebappScripts = 'stripe' | 'hotjar';

@Injectable({ providedIn: 'root' })
export class DocumentExternalScriptsLoader extends ExternalBundlesLoader<WebappScripts> {
  public readonly document: Document;

  constructor() {
    const document = inject<Document>(DOCUMENT);

    super(document);

    this.document = document;
  }
}
